<template>
  <div class="corset-step-two">
    <v-layout
      justify-space-between
      mb-3
    >
      <v-flex sm6>
        <v-switch
          v-model="form.idc_manufacture"
          hide-details
          label="Fabrication :"
          class="title mt-0"
          @change="clearManufactureFields"
        />
        <v-layout mb-3>
          <v-flex>
            <v-radio-group
              v-model="form.type_production"
              hide-details
              row
              :disabled="!form.idc_manufacture"
            >
              <v-radio
                label="Monovalve"
                value="MONOVALVE"
              />
              <v-radio
                label="Bivalve"
                value="BIVALVE"
              />
            </v-radio-group>
          </v-flex>
        </v-layout>

        <v-layout class="checkbox-input-container ma-0">
          <v-flex sm3>
            <v-radio-group
              v-model="form.manufacturing_type"
              hide-details
              row
              :disabled="!form.idc_manufacture"
            >
              <v-radio
                label="PE"
                value="PE"
              />
              <v-radio
                label="PP"
                value="PP"
              />
              <v-radio
                label="ORLEN"
                value="ORLEN"
              />
            </v-radio-group>
          </v-flex>
          <v-radio-group
            v-model="form.manufacturing_thickness"
            hide-details
            row
            :disabled="!form.idc_manufacture || form.manufacturing_type == null"
          >
            <v-radio
              label="3 mm"
              value="3"
            />
            <v-radio
              label="4 mm"
              value="4"
            />
          </v-radio-group>
        </v-layout>

        <v-layout>
          <v-flex sm5>
            <p class="mt-2 mb-2">
              T-shirt :
            </p>
            <v-text-field
              v-model="form.tshirt_quantity"
              v-validate="'numeric|max:4'"
              data-vv-name="(Fabrication) Quantité"
              :class="{ error: errors.has('(Fabrication) Quantité') }"
              type="number"
              label="Quantité"
              hide-details
              outlined
            />
          </v-flex>

          <v-flex
            sm5
            class="ml-4"
          >
            <p class="mt-2 mb-2">
              Taille :
            </p>
            <v-select
              v-model="form.tshirt_size"
              :items="dropdowns.tshirt_size"
              item-text="label"
              item-value="value"
              label
              filled
              clearable
            />
          </v-flex>
        </v-layout>
      </v-flex>

      <v-layout
        sm6
        wrap
      >
        <v-flex>
          <h3 class="mb-2">
            Garnissage :
          </h3>
          <v-layout justify-space-between>
            <v-flex
              sm5
              mb-3
            >
              <v-text-field
                v-model="form.garnishing"
                label
                hide-details
                outlined
                maxlength="20"
                :disabled="!form.idc_manufacture"
              />
            </v-flex>

            <v-layout
              sm7
              class="color-select"
            >
              <v-select
                v-model="form.transfer_id"
                :items="transferColors"
                item-text="label"
                item-value="id"
                hide-details
                label="Transfert :"
                filled
                clearable
                :disabled="!form.idc_manufacture"
              />
              <v-flex
                v-if="previewTransfer"
                class="preview"
                style="width: 35px; height: 35px"
              >
                <img
                  v-if="previewTransfer.texture == 'TEXTURE'"
                  :src="previewTransfer.image"
                  style="width: 100%; height:100%"
                  alt
                >
              </v-flex>
            </v-layout>
          </v-layout>

          <v-text-field
            v-model="form.other_production"
            label="Autres :"
            hide-details
            outlined
            maxlength="20"
            :disabled="!form.idc_manufacture"
          />
        </v-flex>

        <v-layout>
          <v-flex>
            <h3 class="mt-4 mb-2">
              Fermeture Basse :
            </h3>
            <v-checkbox
              v-model="form.idc_velcro_bystander_40"
              label="velcro passant 40"
              hide-details
            />
            <v-checkbox
              v-model="form.idc_velcro_bystander_25"
              label="velcro passant 25"
              hide-details
            />
            <v-checkbox
              v-model="form.idc_clip"
              label="barette"
              hide-details
            />
          </v-flex>

          <v-flex>
            <h3 class="mt-4 mb-2">
              Fermerture Haute :
            </h3>
            <v-checkbox
              v-model="form.idc_rigid_clip"
              label="barrette rigide"
              hide-details
            />
            <v-checkbox
              v-model="form.idc_elastic_clip"
              label="barrette elastique"
              hide-details
            />
            <v-checkbox
              v-model="form.idc_velcro_bystander"
              label="velcro passant"
              hide-details
            />
          </v-flex>
        </v-layout>
      </v-layout>
    </v-layout>

    <v-layout mb-3>
      <v-flex
        justify-space-between
        row
      >
        <v-flex sm2>
          <h3 class="ml-4 mt-2 mb-2">
            Autres :
          </h3>
        </v-flex>
        <v-flex sm5>
          <v-text-field
            v-model="form.material"
            maxlength="20"
            label="Matière :"
            hide-details
            outlined
          />
        </v-flex>

        <v-flex sm5>
          <v-text-field
            v-model="form.thickness"
            v-validate="'numeric|max:4'"
            data-vv-name="(Autres) Epaisseur"
            :class="{ error: errors.has('(Autres) Epaisseur') }"
            type="number"
            label="Epaisseur :"
            hide-details
            outlined
          />
        </v-flex>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex>
        <v-textarea
          v-model="form.comment_production"
          filled
          name="Commentaires :"
          label="Commentaires :"
        />
      </v-flex>
    </v-layout>

    <v-layout justify-space-between>
      <v-flex
        v-for="(section, prop, index) in groupedArticles"
        :key="index"
        column
        sm6
      >
        <h2>{{ prop }}</h2>
        <v-layout
          v-for="article in section"
          :key="article.article_id"
          class="checkbox-input-container"
        >
          <v-flex>
            <v-checkbox
              v-model="form.articles[article.index].idc_want"
              hide-details
            >
              <template v-slot:label>
                <h4>{{ article.article_reference }}</h4>
                <h4>{{ article.label }}</h4>
              </template>
            </v-checkbox>
          </v-flex>
          <v-flex class="checkbox-input">
            <InputNumber
              v-if="article.idc_entry"
              v-model="form.articles[article.index].value"
              class="input-number"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex sm6>
        <v-textarea
          v-model="form.other_lpr"
          filled
          name="Autre LPPR : :"
          label="Autre LPPR"
          value
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { articles } from "@/mixins/articles";

import InputNumber from "@/components/InputNumber.vue";

export default {
  name: "CorsetStepOne",
  components: {
    InputNumber
  },
  mixins: [articles],
  inject: ["parentValidator"],
  props: {
    form: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      transferColors: "colors/getTRANSFERType",
      dropdowns: "dropdowns/getCorsetOptions"
    }),

    // Returns transfer textures
    previewTransfer() {
      return this.transferColors.find(item => item.id == this.form.transfer_id);
    }
  },
  async created() {
    this.$validator = this.parentValidator;

    await this.loadArticles("CORSET", true);

    if (this.form.articles.length <= 0) {
      this.form.articles = this.articles;
    }
  },
  methods: {
    // Clear manufacture fields
    clearManufactureFields() {
      this.form.type_production = null;
      this.form.manufacturing_type = null;
      this.form.manufacturing_thickness = null;
      this.form.garnishing = null;
      this.form.transfer_id = null;
      this.form.other_production = null;
    }
  }
};
</script>

<style lang="scss">
.corset-step-two {
  .content {
    display: flex;
    //min-height: 80vh;
    .img-container {
      position: relative;
      display: inline-block;
      margin: auto;
      img {
        //height: 100%;
        //width: 100%;
        //min-width: 800px;
        @media (max-width: 800px) {
          min-width: auto;
        }
      }
      .v-input {
        position: absolute;
        width: 10.1%;
        height: 8.6%;
        .v-input__control {
          height: 100%;
          .v-input__slot {
            min-height: auto;
          }
        }
      }
    }
  }
  .checkbox-input-container {
    margin-top: 0;
    > div {
      &.checkbox-input {
        position: relative;
        top: 0;
        transform: none;
        margin-left: 15px;
        max-width: 80px !important;
        &:not(.visible) {
          display: none;
        }
      }
    }
  }
  .v-input--selection-controls {
    margin-top: 0;
    &.v-input {
      .v-input__control {
        flex-grow: 1;
      }
      .v-label {
        width: 100%;
        h4 {
          font-size: 10px !important;
          &:first-child {
            color: #333;
            margin-right: 5px;
            font-size: 12px !important;
          }
        }
      }
    }
    .v-input__slot {
      align-items: flex-start;
      overflow: hidden;
      margin-bottom: 15px;
      .v-label {
        align-items: baseline;
      }
    }
  }
}
</style>
